import { Stack } from '@mantine/core'
import { useGetSnmpDevice } from 'api/snmpDevices'
import { Query } from 'components/common'
import { useParams } from 'react-router-dom'
import { TSnmpDevice } from 'shared/types'
import { DeviceKeys } from './DeviceKeys'

export const SnmpKeys = () => {
  const { deviceId } = useParams()
  const query = useGetSnmpDevice(deviceId!)

  return (
    <Query.Wrapper query={query}>
      <Query.Data>
        {(data: TSnmpDevice) => (
          <Stack>
            <DeviceKeys keys={data} />
          </Stack>
        )}
      </Query.Data>
    </Query.Wrapper>
  )
}
